module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/SD-card-9ee7803060d900745ece8a10ace4c59c.svg";